import { render } from "./RecentCustomerRatings.vue?vue&type=template&id=506c3a0c&ts=true"
import script from "./RecentCustomerRatings.vue?vue&type=script&lang=ts"
export * from "./RecentCustomerRatings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__